import React, { useState } from "react";
import { Input } from "antd";

const MaterialLikePasswordInput = ({
    label,
    value,
    onChange,
    required,
    readOnly,
    showValidation = false,
    autoComplete = "off",
    name
}) => {
    const [focused, setFocused] = useState(false);
    const [capsLock, setCapsLock] = useState(false);

    // Validation rules
    const validations = {
        length: value?.length >= 8,
        uppercase: /[A-Z]/.test(value),
        lowercase: /[a-z]/.test(value),
        number: /[0-9]/.test(value),
        special: /[!@#$%^&*]/.test(value),
    };

    // Calculate strength based on validations met
    const strengthCount = Object.values(validations).filter(Boolean).length;
    const progress = (strengthCount / 5) * 100;

    // Handle caps lock detection
    const handleKeyUp = (e) => {
        const caps = e.getModifierState && e.getModifierState("CapsLock");
        setCapsLock(caps);
    };

    return (
        <div
            className={`mui-password-container ${focused || value ? "focused" : ""}`}
        >
            <label className="mui-password-label">
                {/* {(focused || value) && required && <span className="required-star">*</span>} */}
                {required && <span className="required-star">*</span>}{label}
            </label>

            <Input.Password
                value={value}
                name={name || "fake-field"}
                onChange={onChange}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                onKeyUp={handleKeyUp}
                className="mui-password-input"
                bordered={false}
                readOnly={readOnly}
                autoComplete={autoComplete || "new-password"}
            />

            {/* Caps Lock Warning */}
            {capsLock && (
                <div className="caps-warning">Caps Lock is ON</div>
            )}

            {/* Password strength progress bar */}
            {focused && showValidation && (
                <div className="strength-bar mb-3">
                    <div className={`bar ${strengthCount >= 2 ? "active" : ""}`} />
                    <div className={`bar ${strengthCount >= 4 ? "active" : ""}`} />
                    <div className={`bar ${strengthCount === 5 ? "active" : ""}`} />
                </div>
            )}
            {focused && showValidation && (
                <ul className="password-rules">
                    <li className={validations.length ? "valid" : ""}>
                        {validations.length ? "✅" : "❌"} At least 8 characters
                    </li>
                    <li className={validations.uppercase ? "valid" : ""}>
                        {validations.uppercase ? "✅" : "❌"} One uppercase letter
                    </li>
                    <li className={validations.lowercase ? "valid" : ""}>
                        {validations.lowercase ? "✅" : "❌"} One lowercase letter
                    </li>
                    <li className={validations.number ? "valid" : ""}>
                        {validations.number ? "✅" : "❌"} One number
                    </li>
                    <li className={validations.special ? "valid" : ""}>
                        {validations.special ? "✅" : "❌"} One special character (!@#$%^&*)
                    </li>
                </ul>
            )}
        </div>
    );
};

export default MaterialLikePasswordInput;
